import { cn } from "@/lib/utils";
import { expiryLabel, expiryState } from "@/lib/company-expiry";

/** "ističe za N dana" (amber do 30 dana), "istekao" (crveno). Ništa kad je daleko. */
export function ExpiryNote({
  ymd,
  today,
  prefix,
  className,
}: {
  ymd: string;
  today: string;
  /** Npr. "Ugovor" za "Ugovor ističe za 5 dana". */
  prefix?: string;
  className?: string;
}) {
  const state = expiryState(ymd, today);
  if (state === "ok") return null;
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-semibold",
        state === "expired" ? "bg-destructive/10 text-destructive" : "bg-amber-50 text-amber-700",
        className,
      )}
    >
      {prefix ? `${prefix} ${expiryLabel(ymd, today)}` : expiryLabel(ymd, today)}
    </span>
  );
}

/** Da li bilo koji od isteka traži pažnju (≤ 30 dana ili prošao). */
export function needsExpiryAttention(ymd: string | null, today: string): boolean {
  return !!ymd && expiryState(ymd, today) !== "ok";
}
